import { ActionType, Op } from '@walkme/sdk';

export enum ComCenterActionType {
  RemindMeNextTime = 'remindMeNextTime',
  RemindMeNextDay = 'remindMeNextDay',
  Url = 'url',
  TextLink = 'textLink',
  Destory = 'destroy',
}

export type AllActionsTypes = ActionType | ComCenterActionType;

export type insertUrl = Extract<Op['insert'], { url: unknown }>;

export enum LinkTarget {
  NewWindow = '_top',
  NewTab = '_blank',
  ThisWindow = '_self',
}

export interface Action {
  type: AllActionsTypes;
  actionId?: string;
  itemType?: string; // new - enable define app or deployable to 'play' or 'open'
  itemId?: number;
  playFromBeginning?: boolean;
  subItemId?: number;
}
